import { Component, computed, input, output } from "@angular/core";
import { EvTooltipModule } from "ev-tooltip";
import { SergeantTitleComponent } from "../sergeant-title/sergeant-title.component";
import { ClickOutsideDirective } from "ev-directives";
@Component({
    selector: "key-info-physical-exposure",
    templateUrl: "./key-info-physical-exposure.component.html",
    styleUrl: "./key-info-physical-exposure.component.scss",
    imports: [EvTooltipModule, SergeantTitleComponent, ClickOutsideDirective],
})
export class KeyInfoPhysicalExposureComponent {
    tooltipOpen: boolean = false;
    expandDetailsClicked = output<void>();
    closeScoreInformation() {
        this.tooltipOpen = false;
    }
    openScoreInformation() {
        this.tooltipOpen = !this.tooltipOpen;
    }
    physicalExposures = input<IUnitTotalPhysicalExposures>();

    affectingExposures = computed(() => {
        const exposures = this.physicalExposures()?.exposures.filter((exposure) => exposure.isExposed) ?? [];
        const uniqueExposures = Array.from(new Set(exposures.map((d) => d.exposureCategoryName)));

        let aff = uniqueExposures.join(", ");
        if (aff.length > 100) {
            aff = aff.substring(0, 99) + "…";
        }
        return aff;
    });
    goToPhysicalExposures() {
        this.expandDetailsClicked.emit();
    }
}
export interface IUnitTotalPhysicalExposures {
    totalPhysicalRiskScore: number;
    exposures: IPhysicalExposure[];
    physicalRiskSubtitle?: string;
}
export interface IPhysicalExposure {
    exposureImpactName: string;
    exposureCategoryName: string;
    exposureScenarioName: string;
    exposureTypeLevel: string;
    isExposed?: boolean;
    isAnalyzedForExposure?: boolean;
    //    geoPosition?: ILatLng[];
    exposureRiskScore: number;
}
export interface IBusinessManager {
    organizationNumber: string;
    name: string;
    emailAddress: string;
    phoneNumber: string;
    lastAccountingYear: number;
}
export interface IForeclosureDiscount {
    areaMarketScore: number;
    discount: number;
    discountInPercentage: number;
    estateType: number; 
    id: number;
}
